import { render, staticRenderFns } from "./dubbing.vue?vue&type=template&id=0c4e9632&scoped=true"
import script from "./dubbing.vue?vue&type=script&lang=js"
export * from "./dubbing.vue?vue&type=script&lang=js"
import style0 from "./dubbing.vue?vue&type=style&index=0&id=0c4e9632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e9632",
  null
  
)

export default component.exports